import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { z } from "zod";

import { AccountCreate as AccountCreateSection } from "~/components/feature/account-create";
import { selectIsLoadingAuth, selectOnboardingStep } from "~/store";

const accountCreateSearchSchema = z.object({
  step: z.number().int().optional(),
});

export const Route = createFileRoute("/_app/account/create")({
  component: AccountCreate,
  validateSearch: accountCreateSearchSchema,
});

function AccountCreate() {
  const { step } = Route.useSearch();
  const onboardingStep = useSelector(selectOnboardingStep);
  const isLoadingAuth = useSelector(selectIsLoadingAuth);
  const navigate = useNavigate();

  const userStep = onboardingStep ?? 0;
  // If no step param, use user's current step. If step param exists, allow navigation to that step
  const currentStep = step !== undefined ? step : userStep;
  const validStep = Math.max(0, Math.min(currentStep, 2));

  // biome-ignore lint/correctness/useExhaustiveDependencies: navigate is stable from useNavigate
  useEffect(() => {
    if (!isLoadingAuth && step !== validStep) {
      navigate({
        to: "/account/create",
        search: { step: validStep },
        replace: true,
      });
    }
  }, [step, validStep, isLoadingAuth]);

  return <AccountCreateSection initialStep={validStep} />;
}
